export const buildFlightMessageStorageKey = (flightId: string) =>
  `flightviewer.messages.lastSeen.${flightId}`;

export const getLastSeenReceivedAt = (flightId: string): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.localStorage.getItem(buildFlightMessageStorageKey(flightId));
  } catch (error) {
    return null;
  }
};

export const setLastSeenReceivedAt = (flightId: string, timestamp: string | null) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    if (timestamp) {
      window.localStorage.setItem(buildFlightMessageStorageKey(flightId), timestamp);
    } else {
      window.localStorage.removeItem(buildFlightMessageStorageKey(flightId));
    }
  } catch (error) {
  }
};
